import type { App } from "vue";
import {
  InviteDataSourceImpl,
  inviteDataSourceKey,
} from "./data/datasources/invite_datasource";
import {
  RoleDataSourceImpl,
  roleDataSourceKey,
} from "./data/datasources/role_datasource";

import {
  AccountDataSourceImpl,
  accountDataSourceKey,
} from "./data/datasources/account_datasource";
import {
  UserDataSourceImpl,
  userDataSourceKey,
} from "./data/datasources/user_datasource";

export function initAccountModule(app: App) {
  app.provide(roleDataSourceKey, new RoleDataSourceImpl());
  app.provide(inviteDataSourceKey, new InviteDataSourceImpl());
  app.provide(userDataSourceKey, new UserDataSourceImpl());
  app.provide(accountDataSourceKey, new AccountDataSourceImpl());
}
